import { UserProfile, WaitlistEntry } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import {
  waitlistEntrySliderCardPressed as waitlistEntrySliderCardPressedAction,
} from '../../Bookings/actions';
import { GymResolver } from '../../services';
import Theme from '../../theme';
import { getGymTimezone } from '../../utils/gyms';
import getMomentFormat from '../../utils/LocaleMoment';
import { HorizontalScrollerCard } from './HorizontalScrollerCard';
import WorkoutSectionCardWithImageContentWrapper from './WorkoutSectionCardWithImageContentWrapper';
import { workoutSliderCardStyle } from './WorkoutSlider';

interface IProps {
  onlyOneCardInSlider: boolean;
  lastCardInSlider: boolean;
  waitlistEntry: WaitlistEntry;
  waitlistEntrySliderCardPressed: () => void;
  userProfile: UserProfile;
  navigation: {
    navigate: (route: string) => void;
  };
  t: (key: string, options?: any) => string;
}

const BookWorkoutSliderCard: FunctionComponent<IProps> = (
  {
    onlyOneCardInSlider,
    lastCardInSlider,
    waitlistEntrySliderCardPressed,
    waitlistEntry,
    t,
  },
) => {

  const migishaImageHeight = 532;
  const migishaImageWidth = 420;

  const gymTimeZone = getGymTimezone(waitlistEntry);
  const dayOfBookingWithMonth = getMomentFormat(waitlistEntry.timeSlot.startTime, 'ddd D MMM', gymTimeZone);
  const dayOfBooking = getMomentFormat(waitlistEntry.timeSlot.startTime, 'ddd', gymTimeZone);
  const bookingTime = getMomentFormat(waitlistEntry.timeSlot.startTime, 'HH:mm', gymTimeZone);

  const gym = GymResolver.getByName(waitlistEntry.gymName);
  const waitlistSlotOpen = !waitlistEntry.timeSlot.isFull;

  const cardSubheading = waitlistSlotOpen
    ? undefined
    : `${dayOfBooking}, ${bookingTime}, ${gym.displayName}`;

  return (
    <HorizontalScrollerCard
      style={workoutSliderCardStyle.container}
      onPress={waitlistEntrySliderCardPressed}
      wideCard={onlyOneCardInSlider}
      lastCard={lastCardInSlider}
    >
      <WorkoutSectionCardWithImageContentWrapper
        imageHeight={migishaImageHeight}
        imageWidth={migishaImageWidth}
        header={waitlistSlotOpen ? t('bookWaitlistSlotNow') : t('youAreOnTheWaitlist')}
        subHeading={cardSubheading}
        image={require('../../assets/images/workout-cards/pt-migisha.png')}
        alert={waitlistSlotOpen}
      />
      {waitlistSlotOpen &&
        <View style={styles.textContainer}>
          <Text style={styles.bookingText}>
            {t('slotAvailable', {date: dayOfBookingWithMonth})}{'\n'}
            {bookingTime}, {gym.displayName}
          </Text>
        </View>
      }
    </HorizontalScrollerCard>
  );
};

const styles = StyleSheet.create({
  bookingText: {
    ...Theme.textStyle.bodyCopyMed,
    color: Theme.WHITE,
    zIndex: 5,
  },
  textContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});

const mapDispatchToProps = (dispatch, ownProps: IProps) => {
  const { userProfile, waitlistEntry } = ownProps;
  return {
    waitlistEntrySliderCardPressed: () => dispatch(
      waitlistEntrySliderCardPressedAction(userProfile, waitlistEntry),
    ),
  };
};

export default connect(null, mapDispatchToProps)(BookWorkoutSliderCard);
